import { X, Loader2, Navigation } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export const DriverLinkModal = ({
  driverLinkModal, setDriverLinkModal,
  driverLink, setDriverLink,
  paymentLoading, sendDriverLink,
}) => {
  if (!driverLinkModal) return null;

  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={() => setDriverLinkModal(null)}>
      <div className="bg-zinc-900 border border-zinc-700 rounded-xl p-6 w-full max-w-md" onClick={e => e.stopPropagation()}>
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold text-white">Position chauffeur</h3>
          <button onClick={() => setDriverLinkModal(null)} className="text-zinc-400 hover:text-white"><X className="w-5 h-5" /></button>
        </div>
        <p className="text-zinc-400 text-sm mb-4">
          Collez le lien Google Maps de partage de position en temps reel. Le client recevra ce lien par WhatsApp.
        </p>
        <div className="space-y-3">
          <Input
            placeholder="https://maps.app.goo.gl/..."
            value={driverLink}
            onChange={e => setDriverLink(e.target.value)}
            className="bg-zinc-800 border-zinc-700 text-white"
            data-testid="driver-link-input"
          />
          <Button onClick={sendDriverLink} disabled={!driverLink || paymentLoading} className="w-full bg-blue-600 hover:bg-blue-700 text-white" data-testid="send-driver-link-btn">
            {paymentLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Navigation className="w-4 h-4 mr-2" /> Envoyer au client</>}
          </Button>
        </div>
      </div>
    </div>
  );
};
